export default {
  GET_GLOSSARY_REQUESTED: 'GET_GLOSSARY_REQUESTED',
  GET_GLOSSARY_SUCCEEDED: 'GET_GLOSSARY_SUCCEEDED',
  GET_GLOSSARY_FAILED: 'GET_GLOSSARY_FAILED',
};
